import { render, staticRenderFns } from "./BaseUsersStaticField.vue?vue&type=template&id=015650d2&"
import script from "./BaseUsersStaticField.vue?vue&type=script&lang=js&"
export * from "./BaseUsersStaticField.vue?vue&type=script&lang=js&"
import style0 from "./BaseUsersStaticField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BaseUsersStaticField.vue"
export default component.exports